module.exports = __webpack_public_path__ + "static/img/yhyren.2e4862a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/yhyren.png
// module id = u2LY
// module chunks = 0